import React, { ReactNode } from 'react';

import { MetricsBlock } from './MetricsBlock';

const MOCK_VALUES: CampaignAnalyticsMetricsProps['metrics'] = {
  totalSales: '€8,299,23',
  totalSpend: '€1,200.00',
  totalOrders: '2,345',
  newCustomers: '323',
  returningCustomers: '2,121',
  averageBasketSize: '€14.35',
  averageCostPerOrder: '€2.56',
};

type CampaignAnalyticsMetricsProps = {
  title: string;
  headerAction?: ReactNode;
  colored?: boolean;
  isLoading?: boolean;
  metrics?: {
    totalSales: ReactNode;
    totalSpend: ReactNode;
    totalOrders: ReactNode;
    newCustomers: ReactNode;
    returningCustomers: ReactNode;
    averageBasketSize: ReactNode;
    averageCostPerOrder: ReactNode;
  };
};

export const CampaignAnalyticsMetrics = ({
  title,
  headerAction,
  colored,
  isLoading,
  metrics: {
    totalSales,
    totalSpend,
    totalOrders,
    newCustomers,
    returningCustomers,
    averageBasketSize,
    averageCostPerOrder,
  } = MOCK_VALUES,
}: CampaignAnalyticsMetricsProps) => {
  return (
    <MetricsBlock
      title={title}
      headerAction={headerAction}
      colored={colored}
      isLoading={isLoading}
      primaryMetrics={[
        {
          title: 'Total sales',
          value: totalSales,
          tooltip:
            'The total values of goods sold and fees (when applicable) paid by the customer from this campaign. (Does not include rejected orders)',
        },
        { title: 'Total spend', value: totalSpend },
        {
          title: 'Total orders',
          value: totalOrders,
          tooltip: 'The total number of delivered orders from this campaign (does not include rejected orders)',
        },
      ]}
      secondaryMetrics={[
        { title: 'New customers', value: newCustomers },
        { title: 'Returning customers', value: returningCustomers },
        { title: 'Average basket size', value: averageBasketSize },
        {
          title: 'Average cost per order',
          value: averageCostPerOrder,
          tooltip: 'The amount you paid, on average, for each promotion order',
        },
      ]}
    />
  );
};
